import { Component } from 'react';
import { Col, Row, Form, Table, Container } from 'react-bootstrap';
import { IntlProvider } from 'react-intl';

class LTList extends Component {
    constructor(props) {
        super(props);
        const today = new Date();
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

        this.state = {
            races: [],
            date: today.toLocaleDateString('en-CA', options)
        };
    };

    componentDidMount() {
        this.loadResults(this.state.date);
    }

    loadResults = (date) => {
        // We are currently proxying through uscsa.org to add the required CORS headers.
        // This can be changed back to live-timing.com whenever Geoff gets around to fixing that..
        fetch('https://redirect.engine.uscsa.org/lt/dataShareRaces.php?date=' + date, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: {
                accept: 'application/xml'
            },
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        })
            .then(response => {
                return(response.text());
            })
            .then(xml => {
                return (new DOMParser().parseFromString(xml, "application/xml"))
            })
            .then(xmldoc => {
                let parsed_races = []
                //console.log(xmldoc);
                let races = xmldoc.getElementsByTagName('race');
                // This grabs information we want from the xmldoc and builds a json object
                // It's not pretty...
                for (let i = 0; i < races.length; i++) {
                    if (races[i].childNodes[11].innerHTML.includes("USCSA")) {
                        parsed_races.push(
                            {
                                Name: <a href={"https://www.live-timing.com/race2.php?r=" + races[i].childNodes[1].innerHTML}>{races[i].childNodes[11].innerHTML}</a>,
                                Discipline: races[i].childNodes[13].innerHTML,
                                Gender: races[i].childNodes[15].innerHTML,
                                Location: races[i].childNodes[7].innerHTML + ", " + races[i].childNodes[5].innerHTML.toUpperCase(),
                            }
                        )
                    }
                }
                this.setState({ races: parsed_races })
            })
            .catch((err) => {
                console.log("fuck: " + err)
            });
    };

    resultTableHeader = () => {
        if (this.state.races.length > 0) {
            let header = Object.keys(this.state.races[0])
            return header.map((key, index) => {
                return <th key={index}>{key}</th>
            })
        } else {
            return <th key="noraces">No USCSA races were scheduled on live-timing.com on {this.state.date}</th>
        }
    }

    resultTable = () => {
        return (
            <Table hover={true}
                   bordered={true}
                   striped={true}>
                <thead>
                    <tr>{this.resultTableHeader()}</tr>
                </thead>
                <tbody>
                {this.state.races.map((race, index) => (
                    <tr key={index}>
                        <td key={race.Name}>{race.Name}</td>
                        <td key={race.Discipline}>{race.Discipline}</td>
                        <td key={race.Gender}>{race.Gender}</td>
                        <td key={race.Location}>{race.Location}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        );
    };

    render() {
        const onSetDate = (event) => {
            this.setState({date: event.target.value});
            this.loadResults(event.target.value);
        }

        return(
            <IntlProvider locale="en">
                <Container>
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="date">
                            <Form.Label>Race Date</Form.Label>
                            <Form.Control
                                type="date"
                                placeholder="The day the race will happen on (mm/dd/yyyy)"
                                onChange={onSetDate}
                                value={this.state.date}
                            />
                            <Form.Text className="text-muted">
                                The day the race will happen on (mm/dd/yyyy)
                            </Form.Text>
                        </Form.Group>
                    </Row>
                    <this.resultTable/>
                </Container>
            </IntlProvider>
        );
    }
}

export default LTList